<template>
  <v-container grid-list-md>
      <v-card>
        <v-card-title><h2>Set password email template:</h2></v-card-title>
        <v-card-text>

          <v-layout>
            <v-flex xs6>
              <v-select
                :items="emailTempalateForResetPassword"
                item-value="templateKey"
                item-text="templateKey"
                label="Set password template"
                v-model="templateForResetPassword"
                @change="updateEmailTemplate"
              >
              </v-select>
            </v-flex>
          </v-layout>

        </v-card-text>

      </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { pathOr } from 'ramda'

export default {
  name: 'user-settings',
  data() {
    return {
      templateForResetPassword: '',
    }
  },
  computed: {
    ...mapGetters([
      'getEmailTemplates',
      'getEmailTemplatesSettings'
    ]),
    emailTempalateForResetPassword () {
      const resetPasswordTemplates = this.getEmailTemplates.filter(template => template.category === "ResetPassword")
      return resetPasswordTemplates
    }
  },
  watch: {
    getEmailTemplatesSettings: {
      handler (newVal) {
        if (!newVal) return
        this.templateForResetPassword = pathOr('', ['userResetPasswordTemplate'], this.getEmailTemplatesSettings)
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions([
      'fetchEmailTemplates',
      'updateAdminSetPasswordTemplate'
    ]),
    updateEmailTemplate (templateName) {
      this.updateAdminSetPasswordTemplate({ templateName })
    },
    async receiveRequiredData () {
      await this.fetchEmailTemplates()
    }
  },
  created () {
    this.receiveRequiredData()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Users/usersSettings.vue